module.exports = __webpack_public_path__ + "fa16c8328e43f3794644c7b0cbb0954a.MP3";